<template>
  <div style="padding: 10px 0px">
    <el-form :model="formline" label-width="80px" :inline="true">
      <el-form-item label="巡逻日期">
        <el-col :span="11">
          <el-date-picker
          v-model="patrolDate"
            size="small"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placeholder="选择巡逻日期"
            value-format="yyyy/M/d HH:mm:ss"
          >
          </el-date-picker>
          <!-- <el-date-picker size="small" type="date" placeholder="选择巡逻日期" v-model="formline.date" style="width: 180px;" value-format="yyyy/M/d">
					</el-date-picker> -->
        </el-col>
      </el-form-item>
      <el-form-item label="巡逻员">
        <el-input
          size="small"
          v-model="formline.patrol"
          placeholder="请输入巡逻员"
        ></el-input>
        <!-- <el-select  v-model="formline.userId">
							<el-option v-for="s in xjList" :label="s.userName" :value="s.userId"></el-option>
						</el-select> -->
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="query()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          :before-upload="beforeUpload"
          action="/api/admin/bdCheckWorkAttendance/importPatrol"
          name="multipartFile"
          :show-file-list="false"
          :headers="headers"
          :on-success="success"
        >
          <el-button size="small" type="primary">导入巡逻记录</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-table :data="formDate" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <!-- 	<el-table-column prop="username" label="流水号"></el-table-column> -->
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="patrol" label="巡逻员"></el-table-column>
      <el-table-column prop="path" label="路线"></el-table-column>
      <el-table-column prop="startTime" label="开始时间"></el-table-column>
      <el-table-column prop="plan" label="计划"></el-table-column>
      <el-table-column prop="punctuality" label="准时"></el-table-column>
      <el-table-column prop="leakDetection" label="漏巡"></el-table-column>
      <el-table-column prop="earlyPatrol" label="早巡"></el-table-column>
      <el-table-column prop="eveningPatrol" label="晚巡"></el-table-column>
      <el-table-column prop="yield" label="合格率"></el-table-column>
      <el-table-column prop="result" label="结果"></el-table-column>
      <el-table-column prop="duration" label="长度"></el-table-column>
      <el-table-column prop="schedulingType" label="排班类型"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
    </el-table>
    <el-pagination
      v-if="totalNum > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="formline.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
export default {
  data() {
    return {
      headers: {
        //请求头
        Authorization: localStorage.access_token,
      },
      formline: {
        date: null,
        patrol: null,

        page: 1,
        rows: 10,
      },
      patrolDate: [],
      xjList: [],
      formDate: [],
      totalNum: null,
      upLoadLoading: false,
    };
  },
  mounted() {
    this.getAll();
  },
  methods: {
    beforeUpload(file, fileList) {
      this.upLoadLoading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    success(res) {
      this.upLoadLoading.close();
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else {
        this.$message.error("导入失败");
      }
    },
    dc() {
      publicExport(
        "/api/bdCheckWorkAttendance/exportWorkProject",
        this.formline,
        this.type
      );
    },
    getXj() {
      this.$http.get("/api/bdCheckWorkAttendance/selectSecurityUser").then((res) => {
        console.log(res);
        this.xjList = res.data.data;
      });
    },
    query() {
      this.formline.page = 1;
      this.getAll();
    },
    getAll() {
      let closeStartTime = null
      let closeEndTime = null
      if (this.patrolDate && this.patrolDate.length > 1) {
        closeStartTime = this.patrolDate[0]
        closeEndTime = this.patrolDate[1]
      }
      this.$http
        .post("/api/bdCheckWorkAttendance/selectPatrol", {
          ...this.formline,
          closeEndTime,
          closeStartTime
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.formDate = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
          } else {
            this.formDate = [];
            this.totalNum = 0;
          }
        });
    },
    handleCurrentChange(val) {
      this.formline.page = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.formline.rows = val;
      this.getAll();
    },
  },
};
</script>

<style scoped="scoped"></style>
